import {
  Button,
  Icon,
  Switch,
  Text,
} from "@salestrak/ui";
import type { Omittable } from "@salestrak/ui";
import type { ObjectAccessLevel } from "#app/lib/data";
import type { EntityData } from "#app/lib/entity-visuals";
import { AccessLevelMenu } from "./access-level-menu";
import { AccessRowFrame } from "./access-row";
import { LockedLevel } from "./share-rows";

// A row of the add path: someone who may or may not already have access.
// Granted rows carry the same tier menu and switch as the list; the rest
// carry an Add.
export function ResultRow({
  entity,
  label,
  role,
  meta,
  granted,
  locked = false,
  level,
  onAdd,
  onChange,
  onRevoke,
}: Omittable<{
  entity: EntityData;
  label: string;
  role?: string;
  meta?: string;
  granted: boolean;
  locked?: boolean;
  level: ObjectAccessLevel;
  onAdd: () => void;
  onChange: (level: ObjectAccessLevel) => void;
  // Omit when the access cannot be taken away here (a team the item
  // carries on its Teams property comes off there, not in this dialog).
  onRevoke?: () => void;
}>) {
  return (
    <AccessRowFrame entity={entity} label={label} role={role} meta={meta}>
      {locked ? (
        <LockedLevel />
      ) : granted ? (
        <>
          <AccessLevelMenu value={level} onChange={onChange} />
          <Switch
            aria-label={`${label} has access`}
            checked
            disabled={!onRevoke}
            onCheckedChange={() => onRevoke?.()}
            size="sm"
          />
        </>
      ) : (
        <Button
          variant="outline"
          size="sm"
          shape="square"
          // Each result has an Add; the name says whom it adds.
          aria-label={`Add ${label}`}
          onClick={onAdd}
        >
          <Icon name="plus" size="sm" />
          <Text size="sm">Add</Text>
        </Button>
      )}
    </AccessRowFrame>
  );
}
